module.exports = __webpack_public_path__ + "img/team4.b3095ef4.jpg";